import { GetOneSupportTaskInDto, GetOneSupportTaskOutDto } from '../../../types/support-tasks.dto'

export const GET_ONE_SUPPORT_TASK = 'GET_ONE_SUPPORT_TASK'
export const GET_ONE_SUPPORT_TASK_SUCCESS = 'GET_ONE_SUPPORT_TASK_SUCCESS'
export const GET_ONE_SUPPORT_TASK_ERROR = 'GET_ONE_SUPPORT_TASK_ERROR'
export const RESET_GET_ONE_SUPPORT_TASK = 'RESET_GET_ONE_SUPPORT_TASK'

export interface GetOneSupportTask {
  type: typeof GET_ONE_SUPPORT_TASK
  payload: GetOneSupportTaskOutDto
}

export interface GetOneSupportTaskSuccess {
  type: typeof GET_ONE_SUPPORT_TASK_SUCCESS
  payload: GetOneSupportTaskInDto
}

export interface GetOneSupportTaskError {
  type: typeof GET_ONE_SUPPORT_TASK_ERROR
  payload: string | boolean
}

export interface ResetGetOneSupportTask {
  type: typeof RESET_GET_ONE_SUPPORT_TASK
  payload: null
}

export interface State {
  data: GetOneSupportTaskInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetOneSupportTask | GetOneSupportTaskSuccess | GetOneSupportTaskError | ResetGetOneSupportTask
